<div>
  @if (link()) {
  <a
    data-testing-id="product-image-link"
    [routerLink]="linkTarget() || (productURL$ | async)"
    [queryParamsHandling]="computedQueryParamsHandling"
    [queryParams]="{ page: null }"
    tabindex="-1"
    ><ng-container *ngTemplateOutlet="image" /> </a
  >} @else {<ng-container *ngTemplateOutlet="image" />}
</div>

<ng-template #image>
  @if (productImage$ | async; as image) { @if (image.effectiveUrl) {
  <img
    [src]="image.effectiveUrl"
    [alt]="altText() || (defaultAltText$ | async)"
    [attr.loading]="loading()"
    [attr.fetchpriority]="loading() === 'eager' ? 'high' : null"
    [attr.height]="image.imageActualHeight"
    [attr.width]="image.imageActualWidth"
    class="product-image"
    itemprop="image"
    (error)="onImageError($event)"
  />
  } @else {
  <ng-container *ngTemplateOutlet="noImage" />
  } }@else {
  <ng-container *ngTemplateOutlet="noImage" />
  }

  <ng-template #noImage>
    <img
      [src]="fallbackSrc"
      [alt]="'product.image.not_available.alttext' | translate"
      [attr.loading]="loading()"
      [attr.fetchpriority]="loading() === 'eager' ? 'high' : null"
      class="product-image product-image--fallback"
    />
  </ng-template>
</ng-template>
